export function Required() {
  return <b className="text-red-500 ml-0.5">*</b>;
}
